var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "208.92 -563.69 544.469 167.38",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208.92-396.31v-167.38h120q.37 0-.12.27-.49.28-.49.65v98.15q0 .37.49-.12t.12-.49h-96.61v68.92zm219.08 0v-167.38h23.38v72H524v-72h23.38v167.38H524v-72h-72.62v72zm205.23 0v-167.38h120q.37 0-.12.27-.49.28-.49.65v98.15q0 .37.49-.12t.12-.49h-96.61v68.92zm-400.92-92.31h72.61v-50.15h-72.61zm424.31 0h72.61v-50.15h-72.61z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhp);
export default __webpack_public_path__ + "static/media/php.b2a00e40c927ff4e48361bef63765755.svg";
export { ForwardRef as ReactComponent };